import { SET_PAYMENT_ACTIVE_START } from "../constants";

export function setPaymentActiveStart(isPaymentActive) {
  return (dispatch) => {
    dispatch({
      type: SET_PAYMENT_ACTIVE_START,
      isPaymentActive,
    });
  };
}
